import { useTranslation } from 'react-i18next'
import PremiumSlider from '../components/premium-slider'
import HomeFilter from '../components/HomeFilter'
import AnnouncesHome from '../components/announces-home'
import ContactForm from '../components/ContactForm'
import BannerHomepage from '../components/BannerHomepage'

export default function Homepage() {
  const { t } = useTranslation()
  return (
    <>
      <div id='premium-slider' className='text-center w-full align-middle'>
        <PremiumSlider />
      </div>
      <div className='m-2'>
        <BannerHomepage />
      </div>
      <div id='home-filter' className='justify-center text-anthracite'>
        <HomeFilter />
      </div>

      <div
        id='announces-home'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <AnnouncesHome />
      </div>

      <ContactForm />
    </>
  )
}
